import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Layout from "@/layout/index.vue"
import Center from "@/layout/center.vue"
import DataPlatform from "@/layout/dataPlatform"
import RouteView from "@/components/routeView.vue"



Vue.use(VueRouter)

// 管理后台相关路由
const adminRoutes = []

// 前台页面相关路由
const frontRoutes = [
  {
    path: '/',
    component: () => import('@/views/index/index'),
    meta: {
      title: '',
      hidden: true
    }
  },
  {
    path: '/application',
    component: () => import('@/views/login/application'),
    meta: {
      title: '申请体验',
      hasTokenToIndex: true,
      notLogin: true,
      hidden: true
    }
  },
  {
    path: '/previewArea',
    component: () => import('@/views/previewArea/index'),
    meta: {
      title: '预览',
      notLogin: true,
      hidden: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/login/login'),
    meta: {
      title: '登录',
      hasTokenToIndex: true,
      notLogin: true,
      hidden: true
    }
  },
  {
    path: '/notification',
    component: () => import('@/views/login/notification'),
    meta: {
      title: '通知',
      hasTokenToIndex: true,
      notLogin: true,
      hidden: true
    }
  },
  {
    path: '/explore',
    component: Center,
    redirect: '/explore/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/center/explore/index'),
      }
    ]
  },
  {
    path: '/apply',
    component: Center,
    redirect: '/apply/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/center/apply/index'),
      }
    ]
  },
  {
    path: '/agent',
    component: Center,
    redirect: '/agent/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/center/agent/index'),
      }
    ]
  },
  {
    path: '/chat',
    component: Center,
    redirect: '/chat/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/center/chat/index'),
      }
    ]
  },
  {
    path: '/home',
    component: Center,
    redirect: '/home/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/center/home/index'),
      }
    ]
  },
  {
    path: '/assistant',
    component: Center,
    redirect: '/assistant/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/center/assistant/index'),
      }
    ]
  },
  {
    path: '/knowledge',
    component: Center,
    redirect: '/knowledge/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/center/knowledge/index'),
      },
      {
        path: 'detail',
        component: () => import('@/views/center/knowledge/detail'),
        meta: {
          hidden: true
        }
      }
    ]
  },
  {
    path: '/apply/detail',
    component: () => import('@/views/center/apply/detail'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/agent/arrange',
    component: () => import('@/views/center/agent/arrange'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/agent/chat',
    component: () => import('@/views/center/agent/chat'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/apply/ocr',
    component: () => import('@/views/center/apply/ocr'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/apply/customize',
    component: () => import('@/views/center/apply/component/customize'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/apply/contract',
    component: () => import('@/views/center/apply/component/contract'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/apply/writing',
    component: () => import('@/views/center/apply/component/writing'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/test',
    component: () => import('@/views/index/test.vue'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/report/detail',
    component: () => import('@/views/center/report/detail.vue'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/report/template',
    component: () => import('@/views/center/report/template.vue'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/report',
    component: () => import('@/views/center/report/index.vue'),
    meta: {
      hidden: true,
      notLogin: true
    }
  },
  {
    path: '/smart/report',
    component: () => import('@/views/center/report/smart.vue'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/report/analysis',
    component: () => import('@/views/center/report/analysis.vue'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/report/chat',
    component: () => import('@/views/center/report/chat.vue'),
    meta: {
      hidden: true
    }
  }
]


// 数据平台路由
const dataPlatformRoutes = [
  {
    path: '/dataPlatform',
    name: 'DataPlatform',
    meta: {
      title: '数据平台'
    },
    component: DataPlatform,
    redirect: '/dataPlatform/dataAsyc',
    children: [
      {
        path: 'dataAsyc',
        name: 'DataAsyc',
        meta: {
          title: '数据同步',
          tip: '数据同步',
        },
        component: { render(c) { return c('router-view') } },
        redirect: '/dataPlatform/dataAsyc/fileManage',
        children:[
          {
            path: 'fileManage',
            name: 'FileManage',
            meta: {
              title: '文件管理',
              icon: require('@/assets/images/menuIco/fileManage.png'),
              iconActive: require('@/assets/images/menuIco/fileManage-active.png'),
            },
            component: () => import('@/views/dataPlatform/dataAsyc/index'),
          },
          {
            path: 'database',
            name: 'Database',
            meta: {
              title: '数据库',
              icon: require('@/assets/images/menuIco/database.png'),
              iconActive: require('@/assets/images/menuIco/database-active.png'),
            },
            component: () => import('@/views/dataPlatform/database/index'),
          },
          {
            path: 'largePlatform',
            name: 'LargePlatform',
            meta: {
              title: '大平台数据',
              icon: require('@/assets/images/menuIco/largePlatform.png'),
              iconActive: require('@/assets/images/menuIco/largePlatform-active.png'),
            },
            component: () => import('@/views/dataPlatform/largePlatform/index'),
          },
          {
            path: 'collectionTask',
            name: 'CollectionTask',
            meta: {
              title: '采集任务',
              icon: require('@/assets/images/menuIco/collectionTask.png'),
              iconActive: require('@/assets/images/menuIco/collectionTask-active.png'),
            },
            component: () => import('@/views/dataPlatform/collectionTask/index'),
          },
          {
            path: 'transmissionTask',
            name: 'TransmissionTask',
            meta: {
              title: '传输任务',
              icon: require('@/assets/images/menuIco/fileManage.png'),
              iconActive: require('@/assets/images/menuIco/fileManage-active.png'),
            },
            component: () => import('@/views/dataPlatform/transmissionTask/index'),
          },
        ]
      },
      {
        path: 'mcpManage',
        name: 'McpManage',
        meta: {
          title: 'MCP'
        },
        component: { render(c) { return c('router-view') } },
        redirect: '/dataPlatform/toolbox/manager',
        children: [
          {
            path: 'index',
            name: 'McpManageIndex',
            meta: {
              title: 'MCP管理',
              icon: require('@/assets/images/menuIco/mcpManage.png'),
              iconActive: require('@/assets/images/menuIco/mcpManage-active.png'),
            },
            component: () => import('@/views/dataPlatform/mcpManage/index'),
          },
        ]
      },
      {
        path: 'convertToMd',
        name: 'ConvertToMd',
        meta: {
          title: '文件转MD',
          hide: true,
        },
        component: () => import('@/views/dataPlatform/convertToMd/index.vue'),
        children:[]
      },
      {
        path: 'toolbox',
        name: 'Toolbox',
        meta: {
          title: '工具箱'
        },
        component: { render(c) { return c('router-view') } },
        redirect: '/dataPlatform/toolbox/manager',
        children: [
          {
            path: 'manager',
            name: 'ToolboxManager',
            meta: {
              title: '工具管理',
              icon: require('@/assets/images/menuIco/manager.png'),
              iconActive: require('@/assets/images/menuIco/manager-active.png'),
            },
            component: () => import('@/views/dataPlatform/toolbox/manager/index'),
          },
          {
            path: 'fitter',
            name: 'ToolboxFitter',
            meta: {
              title: '适配器',
              icon: require('@/assets/images/menuIco/fitter.png'),
              iconActive: require('@/assets/images/menuIco/fitter-active.png')
            },
            component: () => import('@/views/dataPlatform/toolbox/fitter/index'),
          },
        ]
      },
      {
        path: 'appMarket',
        name: 'AppMarket',
        meta: {
          title: '应用市场'
        },
        component: { render(c) { return c('router-view') } },
        redirect: '/dataPlatform/toolbox/manager',
        children: [
          {
            path: 'index',
            name: 'AppMarketIndex',
            meta: {
              title: '应用市场',
              icon: require('@/assets/images/menuIco/appMarket.png'),
              iconActive: require('@/assets/images/menuIco/appMarket-active.png'),
            },
            component: () => import('@/views/dataPlatform/appMarket/index'),
          },
        ]
      },
    ]
  },
]



const routes = [
  ...adminRoutes,
  ...dataPlatformRoutes,
  ...frontRoutes,
  
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  frontRoutes,
  adminRoutes,
  dataPlatformRoutes,
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - AI助手` : 'AI助手'
  const ssoToken = to.query.sso_token;
  const token = to.query.token;
  const systemType = to.query.s_type;
  if (ssoToken) {
    store.dispatch('user/setSsoToken', ssoToken)
    store.dispatch('user/setSystemType', systemType)
    next()
    return
  }
  if (token) {
    store.dispatch('user/setToken', token)
  }
  const isLoggedIn = store.getters['user/isAuthenticated'] // 从Vuex获取登录状态
  // 检查是否需要登录权限
  if (!to.matched.some(record => record.meta.notLogin)) {
    if (!isLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      if (store.getters['user/permissions'].length === 0) {
        store.dispatch('user/setUserInfo').then((data) => {
          const permissions = data.permissions;
          // 先添加动态路由并确认添加成功
          const routesAdded = addDynamicRoute(permissions);
          // 添加完路由后再进行导航
          if (routesAdded) {
            // 使用 Vue.nextTick 确保 DOM 更新后再导航
            Vue.nextTick(() => {
              next({ ...to, replace: true });
            });
          } else {
            next();
          }
        }).catch(error => {
          console.error('Error loading menu permissions:', error)
          // 获取用户信息失败时，清除token并跳转到登录页
          store.dispatch('user/clearToken')
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        })
      } else {
        next()
      }
    }
  } else {
    //如果登录状态为true，继续打开登录或者试用的话，则跳转到首页
    if (isLoggedIn && to.meta.hasTokenToIndex) {
      next({ path: '/' })
      return
    }
    next()
  }
})

// 动态添加路由权限
function addDynamicRoute(permissions) {
  // 清空当前adminRoutes数组
  adminRoutes.splice(0, adminRoutes.length);

  // 将接口返回的菜单权限添加到adminRoutes
  if (Array.isArray(permissions) && permissions.length > 0) {
    permissions.forEach(menu => {
      const route = buildRouteFromPermission(menu);
      if (route) {
        adminRoutes.push(route);
      }
    });

    // 动态添加路由
    router.options.routes = [
      ...adminRoutes,
      ...dataPlatformRoutes,
      ...frontRoutes
    ];

    // 重新添加路由
    router.matcher = new VueRouter({
      // mode: 'history',
      // base: process.env.BASE_URL,
      routes: router.options.routes
    }).matcher;

    // 确保路由刷新完成
    return true;
  }
  return false;
}

// 根据权限菜单构建路由对象
function buildRouteFromPermission(menu) {
  if (!menu.path) return null;

  const route = {
    path: menu.path,
    meta: menu.meta
  };

  // 设置组件
  if (menu.component) {
    if (menu.component === 'Layout') {
      route.component = Layout;
    } else if (menu.component === 'RouteView') {
      route.component = RouteView;
    } else {
      // 接口返回的组件路径需要添加 '@/views' 前缀
      try {
        route.component = () => import(/* webpackChunkName: "[request]" */ `@/views/${menu.component}`);
      } catch (e) {
        console.error(`Cannot load component: @/views/${menu.component}`, e);
        return null;
      }
    }
  }

  // 设置重定向
  if (menu.redirect) {
    route.redirect = menu.redirect;
  }

  // 处理子路由
  if (Array.isArray(menu.children) && menu.children.length > 0) {
    route.children = menu.children.map(child => buildRouteFromPermission(child))
      .filter(Boolean); // 过滤掉可能的null值
  }

  return route;
}
export default router
